/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */
require("./seo");
require("./bootstrap-front");
require("./enquiry-form");

// require("./hammer"); //Mobile swipe gestures used for featherlight gallery
require("./jquery.detect_swipe");
require("./callouts"); //Callouts Scrollbar
require("featherlight");
require("./featherlight-gallery");
require("./forms.js");
require("./search.js");
require("./offcanvas.js");
require("./request-a-quote.js");
require("./recaptcha.js");
require("./read-more.js");
// Components
require("./carousels");
require("./component-image-overlay");
require("./component-image-link");
require("./component-archive");
require("./component-team-member");
require("./modal");
require("./video.js");
require("./mobile.js");
require("./cart.js");
require("./user-form-submit.js");
//Popups
require("./popup.js");

window.Vue = require("vue");

//VUE Production Settings (comment out in dev)
Vue.config.devtools = false
Vue.config.debug = false
Vue.config.silent = true

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 **/

Vue.component(
	"component-archive",
	require("./components/ComponentArchive.vue")
);
Vue.component(
	"component-social",
	require("./components/ComponentSocial.vue")
);
Vue.component('pagination', require('laravel-vue-pagination'));

$(document).ready(function() {
	if (document.querySelector("#app")) {
		const app = new Vue({
			el: "#app"
		});
	}
});

$(document).ready(function() {
	let maps = document.querySelectorAll(".map");
	// let maps = Array.from(document.querySelectorAll(".map"));

	if (maps.length && window.google_api_key) {
		const script = document.createElement("script");
		script.src = "https://maps.googleapis.com/maps/api/js?key=" + window.google_api_key; //set as window variable
		document.head.appendChild(script);


		script.onload = function() {
			maps.forEach(function(map) {
				let address = map.dataset.address;
				var geocoder = new google.maps.Geocoder();

				geocoder.geocode({ address: address }, function(
					results,
					status
				) {
					if (status === "OK") {
						let currentMap = new google.maps.Map(map, {
							zoom: 14,
							center: results[0].geometry.location
						});
						/*map.setCenter(results[0].geometry.location);*/
						let marker = new google.maps.Marker({
							map: currentMap,
							position: results[0].geometry.location
						});
					} else {
						console.log(
							"Geocode was not successful for the following reason: " +
								status
						);
					}
				});
			});
		};
	}

	$("table").addClass("table");

	$(".gallery a").featherlightGallery({
		gallery: {
			fadeIn: 300,
			fadeOut: 300
		},
		openSpeed: 300,
		closeSpeed: 300
	});
});

$(document).ready(function() {
	// Gets the video src from the data-src on each button
	var $videoSrc;
	$(".video-btn").click(function() {
		$videoSrc = $(this).data("src");
	});

	// when the modal is opened autoplay it
	$("#video-modal").on("shown.bs.modal", function(e) {
		// set the video src to autoplay and not to show related video. Youtube related video is like a box of chocolates... you never know what you're gonna get
		$("#video-modal-iframe").attr(
			"src",
			$videoSrc +
				"?rel=0&amp;showinfo=0&amp;modestbranding=1&amp;autoplay=1"
		);
	});

	// stop playing the youtube video when I close the modal
	$("#video-modal").on("hide.bs.modal", function(e) {
		// a poor man's stop video
		$("#video-modal-iframe").attr("src", $videoSrc);
	});

	// document ready
});



// $(document).ready(function() {
//     $(window).scroll(function(){
//         if ($(this).scrollTop() > 100) {
//             $('#scroll').fadeIn();
//         } else {
//             $('#scroll').fadeOut();
//         }
//     });
//     $('#scroll').click(function(){
//         $("html, body").animate({ scrollTop: 0 }, 600);
//         return false;
//     });
// });

$(document).ready(function() {
	$(window).resize(function() {
		if ($(window).width() > 991) {
			$('#nav-menu-primary').removeClass('open');
			$('.nav-item.dropdown').removeClass('show');
			$('.dropdown-menu').removeClass('show');
			$('html').removeClass('no-scroll');
		}
	});
});

/*! modernizr 3.6.0 (Custom Build) | MIT *
* https://modernizr.com/download/?-objectfit-setclasses !*/
!function(e,n,t){function r(e,n){return typeof e===n}function o(){var e,n,t,o,i,s,a;for(var l in C)if(C.hasOwnProperty(l)){if(e=[],n=C[l],n.name&&(e.push(n.name.toLowerCase()),n.options&&n.options.aliases&&n.options.aliases.length))for(t=0;t<n.options.aliases.length;t++)e.push(n.options.aliases[t].toLowerCase());for(o=r(n.fn,"function")?n.fn():n.fn,i=0;i<e.length;i++)s=e[i],a=s.split("."),1===a.length?Modernizr[a[0]]=o:(!Modernizr[a[0]]||Modernizr[a[0]]instanceof Boolean||(Modernizr[a[0]]=new Boolean(Modernizr[a[0]])),Modernizr[a[0]][a[1]]=o),h.push((o?"":"no-")+a.join("-"))}}function i(e){var n=_.className,t=Modernizr._config.classPrefix||"";if(w&&(n=n.baseVal),Modernizr._config.enableJSClass){var r=new RegExp("(^|\\s)"+t+"no-js(\\s|$)");n=n.replace(r,"$1"+t+"js$2")}Modernizr._config.enableClasses&&(n+=" "+t+e.join(" "+t),w?_.className.baseVal=n:_.className=n)}function s(e){return e.replace(/([a-z])-([a-z])/g,function(e,n,t){return n+t.toUpperCase()}).replace(/^-/,"")}function a(e,n){return function(){return e.apply(n,arguments)}}function l(e,n,t){var o;for(var i in e)if(e[i]in n)return t===!1?e[i]:(o=n[e[i]],r(o,"function")?a(o,t||n):o);return!1}function f(e,n){return!!~(""+e).indexOf(n)}function u(){return"function"!=typeof n.createElement?n.createElement(arguments[0]):w?n.createElementNS.call(n,"http://www.w3.org/2000/svg",arguments[0]):n.createElement.apply(n,arguments)}function p(e){return e.replace(/([A-Z])/g,function(e,n){return"-"+n.toLowerCase()}).replace(/^ms-/,"-ms-")}function c(n,t,r){var o;if("getComputedStyle"in e){o=getComputedStyle.call(e,n,t);var i=e.console;if(null!==o)r&&(o=o.getPropertyValue(r));else if(i){var s=i.error?"error":"log";i[s].call(i,"getComputedStyle returning null, its possible modernizr test results are inaccurate")}}else o=!t&&n.currentStyle&&n.currentStyle[r];return o}function d(){var e=n.body;return e||(e=u(w?"svg":"body"),e.fake=!0),e}function m(e,t,r,o){var i,s,a,l,f="modernizr",p=u("div"),c=d();if(parseInt(r,10))for(;r--;)a=u("div"),a.id=o?o[r]:f+(r+1),p.appendChild(a);return i=u("style"),i.type="text/css",i.id="s"+f,(c.fake?c:p).appendChild(i),c.appendChild(p),i.styleSheet?i.styleSheet.cssText=e:i.appendChild(n.createTextNode(e)),p.id=f,c.fake&&(c.style.background="",c.style.overflow="hidden",l=_.style.overflow,_.style.overflow="hidden",_.appendChild(c)),s=t(p,e),c.fake?(c.parentNode.removeChild(c),_.style.overflow=l,_.offsetHeight):p.parentNode.removeChild(p),!!s}function v(n,r){var o=n.length;if("CSS"in e&&"supports"in e.CSS){for(;o--;)if(e.CSS.supports(p(n[o]),r))return!0;return!1}if("CSSSupportsRule"in e){for(var i=[];o--;)i.push("("+p(n[o])+":"+r+")");return i=i.join(" or "),m("@supports ("+i+") { #modernizr { position: absolute; } }",function(e){return"absolute"==c(e,null,"position")})}return t}function y(e,n,o,i){function a(){p&&(delete P.style,delete P.modElem)}if(i=r(i,"undefined")?!1:i,!r(o,"undefined")){var l=v(e,o);if(!r(l,"undefined"))return l}for(var p,c,d,m,y,g=["modernizr","tspan","samp"];!P.style&&g.length;)p=!0,P.modElem=u(g.shift()),P.style=P.modElem.style;for(d=e.length,c=0;d>c;c++)if(m=e[c],y=P.style[m],f(m,"-")&&(m=s(m)),P.style[m]!==t){if(i||r(o,"undefined"))return a(),"pfx"==n?m:!0;try{P.style[m]=o}catch(h){}if(P.style[m]!=y)return a(),"pfx"==n?m:!0}return a(),!1}function g(e,n,t,o,i){var s=e.charAt(0).toUpperCase()+e.slice(1),a=(e+" "+E.join(s+" ")+s).split(" ");return r(n,"string")||r(n,"undefined")?y(a,n,o,i):(a=(e+" "+b.join(s+" ")+s).split(" "),l(a,n,t))}var h=[],C=[],S={_version:"3.6.0",_config:{classPrefix:"",enableClasses:!0,enableJSClass:!0,usePrefixes:!0},_q:[],on:function(e,n){var t=this;setTimeout(function(){n(t[e])},0)},addTest:function(e,n,t){C.push({name:e,fn:n,options:t})},addAsyncTest:function(e){C.push({name:null,fn:e})}},Modernizr=function(){};Modernizr.prototype=S,Modernizr=new Modernizr;var _=n.documentElement,w="svg"===_.nodeName.toLowerCase(),x="Moz O ms Webkit",b=S._config.usePrefixes?x.toLowerCase().split(" "):[];S._domPrefixes=b;var E=S._config.usePrefixes?x.split(" "):[];S._cssomPrefixes=E;var j=function(n){var r,o=prefixes.length,i=e.CSSRule;if("undefined"==typeof i)return t;if(!n)return!1;if(n=n.replace(/^@/,""),r=n.replace(/-/g,"_").toUpperCase()+"_RULE",r in i)return"@"+n;for(var s=0;o>s;s++){var a=prefixes[s],l=a.toUpperCase()+"_"+r;if(l in i)return"@-"+a.toLowerCase()+"-"+n}return!1};S.atRule=j;var z={elem:u("modernizr")};Modernizr._q.push(function(){delete z.elem});var P={style:z.elem.style};Modernizr._q.unshift(function(){delete P.style}),S.testAllProps=g;var N=S.prefixed=function(e,n,t){return 0===e.indexOf("@")?j(e):(-1!=e.indexOf("-")&&(e=s(e)),n?g(e,n,t):g(e,"pfx"))};Modernizr.addTest("objectfit",!!N("objectFit"),{aliases:["object-fit"]}),o(),i(h),delete S.addTest,delete S.addAsyncTest;for(var T=0;T<Modernizr._q.length;T++)Modernizr._q[T]();e.Modernizr=Modernizr}(window,document);
function objectFitPolyfill() {
    if ( ! Modernizr.objectfit ) {
        $('header .carousel .carousel-item img, img.objectfit, img.embed-responsive-item').each(function(){
            var imgSrc = $(this).attr('src');
            var fitType = 'cover';

            if ($(this).data('fit-type')) {
                fitType = $(this).data('fit-type');
            }
            $(this).parent().css({ 'background' : 'transparent url("'+imgSrc+'") no-repeat center center/'+fitType, });
			$(this).remove();
		});
    }
}



$(document).ready(function() {
	objectFitPolyfill()
});